var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.26026 0H22.7397C25.6303 0 28 2.36501 28 5.26026V22.7397C28 25.6303 25.635 28 22.7397 28H5.26026C2.36501 28 0 25.6303 0 22.7397V5.26026C0 2.36501 2.36501 0 5.26026 0Z",
    fill: "#0050C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20257 6.54688C7.17022 6.54688 6.33496 7.38214 6.33496 8.41448C6.33496 9.44683 7.17022 10.2821 8.20257 10.2821C9.23491 10.2821 10.0702 9.44683 10.0702 8.41448C10.0702 7.38214 9.23491 6.54688 8.20257 6.54688Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88756 11.5352H6.51367V21.807H9.88756V11.5352Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9115 11.2949C16.6117 11.2949 15.7013 11.9143 15.0632 12.7074V11.5389H11.6846V21.8108H15.0585V15.7903C15.1476 14.4952 16.072 14.1573 16.729 14.1573C17.4188 14.1573 18.2916 14.4952 18.2916 16.3816V21.8061H21.6655V16.3816V14.575C21.6702 14.575 21.5153 11.2949 17.9115 11.2949Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.443949d3e45bb89bcffff642c7b8f426.svg";
export { ForwardRef as ReactComponent };